import { observer } from "mobx-react-lite";

import { Graph } from "@/components/doc/right-sidebar/graph-preview/Graph";
import { useGraphPreview } from "@/components/doc/right-sidebar/graph-preview/useGraphPreview";

import type { DocumentModel } from "@/models/DocumentModel";
import type { GraphNodeModel } from "@/models/nodes/GraphNodeModel";
import type { NodeModel } from "@/models/nodes/types";

type Props = {
  doc: DocumentModel;
  expressions?: NodeModel[][];
  onInsert?: (node: GraphNodeModel) => void;
};

export const GraphPreview = observer(function GraphPreview({
  doc,
  expressions = [],
  onInsert,
}: Props) {
  const {
    ref,
    api,
    expression,
    commandRunner: { evalStatus },
  } = useGraphPreview(expressions, { width: 250, height: 200 }, doc);
  const hideGraph = !expression || evalStatus !== "success";

  return (
    <Graph
      ref={ref}
      doc={doc}
      expression={expression}
      expressions={expressions}
      api={api}
      onInsert={onInsert}
      hidden={hideGraph}
    />
  );
});
